import { useEffect, useState } from 'react';
import { mailModelManager, type ModelProgress } from '../services/model-manager';

export function useMailModel() {
  const [progress, setProgress] = useState<ModelProgress>({ status: 'idle' });

  useEffect(() => {
    return mailModelManager.onProgress(setProgress);
  }, []);

  return {
    status: progress.status,
    downloadProgress: progress.downloadProgress,
    error: progress.error,
    isReady: progress.status === 'ready',
    suggest: mailModelManager.suggest.bind(mailModelManager),
  };
}
